import MetaDataRedux from './meta_data_redux';

export default MetaDataRedux;
